module.exports = __webpack_public_path__ + "static/media/vertex-foods.f53ca54c.jpg";